import Vue from 'vue';
import Vuex from 'vuex';
import { api } from '@/services/services.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    login: false,
    usuario: {
      id: '',
      nome: '',
      email: '',
      senha: '',
    },
    alliances: [],
  },
  getters: {},
  mutations: {
    UPDATE_LOGIN(state, payload) {
      state.login = payload;
    },
    UPDATE_USUARIO(state, payload) {
      state.usuario = Object.assign({}, state.usuario, payload);
    },
    UPDATE_ALLIANCES(state, payload) {
      state.alliances = payload;
    },
  },
  actions: {
    getUsuario(context) {
      return api.get(`usuario`).then((response) => {
        context.commit('UPDATE_USUARIO', response.data);
        context.commit('UPDATE_LOGIN', true);
      });
    },
    logarUsuario(context, payload) {
      return api
        .login({
          email: payload.email,
          senha: payload.senha,
          recaptcha: payload.recaptcha,
        })
        .then((response) => {
          window.localStorage.token = response.data.chave;

          // Salva usuário
          context.commit('UPDATE_USUARIO', response.data.usuario);
          context.commit('UPDATE_LOGIN', true);
        });
    },
    deslogarUsuario(context) {
      context.commit('UPDATE_USUARIO', {
        id: '',
        nome: '',
        email: '',
        senha: '',
      });
      window.localStorage.removeItem('token');
      context.commit('UPDATE_LOGIN', false);
    },
    fetchAlliances({ commit }) {
      return api.get('alliances/lista').then((response) => {
        commit('UPDATE_ALLIANCES', response.data);
      });
    },
    validateToken({ commit }) {
      return api
        .validateToken()
        .then((response) => {
          if (response.data.valido) {
            commit('UPDATE_USUARIO', response.data.dados);
            commit('UPDATE_LOGIN', true);
            return true;
          } else {
            commit('UPDATE_LOGIN', false);
            window.localStorage.removeItem('token');
            return false;
          }
        })
        .catch(() => {
          commit('UPDATE_LOGIN', false);
          window.localStorage.removeItem('token');
          return false;
        });
    },
  },
  modules: {},
});
